import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`About`}</h2>
    <p>{`I am a software Engineer passionate about building new softwares and improving existing ones. I build for the web with JavaScript and build for Mobile with Flutter. I also share my knowledge on my blog. When i'm not working,
you can always find me playing American football, basketball or gaming with my friends for bragging rights :)`}</p>
    <p>{`Languages: JavaScript, Dart, Python`}</p>
    <p>{`Frameworks & Tools: Mongo DB, Express JS, React JS, Node JS, Flutter, Git, Heroku, Firebase, Visual Studio, Anaconda, Netlify.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      